import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import "assets/vendors/style";
//import defaultTheme from "./themes/defaultTheme";
import AppLocale from "../lngProvider";
import { switchLanguage } from "actions/Setting";
import MainApp from "app/index";
import RTL from "util/RTL";
import asyncComponent from "util/asyncComponent";
import { postUserOtherAuthCheck } from "../api/auth";
import config from "../config";
import {
  userSignIn,
  userUpdate,
  userSignInSuccess,
  setUser
} from "actions/Auth";
import languageData from "../components/LanguageSwitcher/data";
import { IntlProvider } from "react-intl";
import { LiveTvRounded } from "@material-ui/icons";

class App extends Component {

  componentDidMount = async () => {
    const paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);

    let token = params.get("t") !== null ? params.get("t").split("?")[0] : "";
    const language = params.get("t") !== null ? params.get("t").split("?")[2] : "tr";
    const url =  params.get("t") !== null ? params.get("t").split("?")[3] : "";
    const activityId =  params.get("t") !== null ? params.get("t").split("?")[4] : 0;

    this.setState({activityId})


  //  //console.log("gdata didmount ", url , userId,token,language,activityId,pwd  );
    if( token === null)
    {
      if(localStorage.getItem("userTokenBilsis") === null || localStorage.getItem("userTokenBilsis") === "null")
    {
      localStorage.removeItem("userTokenBilsis");
      window.location.href =  config.mainPageUrl + `?status=false&message=Yetkisiz erişim`;
    }
    }

    console.log('localStorage.getItem("userTokenBilsis") ', localStorage.getItem("userTokenBilsis"))
console.log('durum ', localStorage.getItem("userTokenBilsis") !== token && token === null && localStorage.getItem("userTokenBilsis") !== null )
 
if(token==="")
{
  token = localStorage.getItem("userTokenBilsis");
}
    const data = { token }; 

    if(localStorage.getItem("userTokenBilsis") === null ||     localStorage.getItem("userTokenBilsis") === "null" || !(localStorage.getItem("userTokenBilsis") !== token && token === null && localStorage.getItem("userTokenBilsis") !== null))
    
    {

      
      if (language !== "" && (language !== null) & (language !== undefined))
      this.props.switchLanguage(
        languageData.find(ld => ld.locale === language)
      );
    else
      this.props.switchLanguage({
        languageId: "turkish",
        locale: "tr",
        name: "Türkçe",
        icon: "tr"
      });
console.log('token ', token )

    localStorage.setItem("userTokenBilsis", token);

    const result = await postUserOtherAuthCheck(data).catch(error => {
   
      if (error.response.status === 403)
     {  
        return {
          status: false,
          message:
            this.props.locale.locale === "tr"
              ? "Hata Oluştu. Oturum sona erdi."
              : "Error oncurred. Session failed"
        }
      }
      else {

        const result1=  { status: false, message: "Error :" + error }
      //  //console.log("buurada sıkıntı ",result1);
        return result1;
      };
    });

  // //console.log("******************************************* result", result);
    if (result.status) {
      const { user } = result;
      await this.props.userSignIn({ user, token });

      if(url === "/bilsis/sendSubmission")
      return  <Redirect to={"/bys/addSubmissionPage/"+activityId} />
      else
      return <Redirect to={"/bys/mainPage"} />

    } else {
     // localStorage.removeItem("userTokenBilsis");
      const { message } = result;
      window.location.href =  config.mainPageUrl + `?status=false&message=${message}`;
    }


    }
    else
    {
      if(url === "/bilsis/sendSubmission")
      return  <Redirect to={`/bys/addSubmissionPage/${activityId}`} />
      else
      return <Redirect to={"/bys/mainPage"} />

    }


    
   // //console.log("gdata didmount 2 ", url );
  };

  render() {
   


    const { match, location, locale, isDirectionRTL } = this.props;

    if (location.pathname === "/" && this.props.user !== null) {
      return <Redirect to={"/bys/mainPage"} />;
    }
    else if (location.pathname === "/bilsis/sendSubmission" && this.props.user !== null) {
      return  <Redirect to={`/bys/addSubmissionPage/${this.state.activityId}`} />
    }
      const applyTheme = createMuiTheme({
        spacing: 8,
      typography: {
        useNextVariants: true,
        
      },
    });
  //  const applyTheme = createMuiTheme(defaultTheme);

    if (isDirectionRTL) {
      applyTheme.direction = "rtl";
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
      applyTheme.direction = "ltr";
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      
      <MuiThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>

          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <RTL>
              <div className="app-main">
                <Switch>
                  <Route path={`${match.url}bys`} component={MainApp} />
                  <Route
                    component={asyncComponent(() =>
                      import("components/Error404")
                    )}
                  />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
          
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings }, state) => {
//  //console.log("appp js state", state);
  const { sideNavColor, locale, isDirectionRTL } = settings;
  const userName =
    state.authUser !== undefined
      ? state.authUser.name + " " + state.authUser.surname
      : null;
  const user = state.authUser;
  return { sideNavColor, locale, isDirectionRTL, user, userName };
};

export default connect(
  mapStateToProps,
  { userUpdate, userSignIn, userSignInSuccess, setUser, switchLanguage }
)(App);
